import store from '../store';

import Page from '../views/ecommerce/Pages.vue';
import EmailTemplate from '../views/ecommerce/EmailTemplate.vue';
import Layout from '../views/ecommerce/Layout.vue';
import ShippingMethod from '../views/ecommerce/ShippingMethod.vue';
import ShippingCost from '../views/ecommerce/ShippingCost.vue';
import HighlightedCategories from '../views/ecommerce/HighlightedCategories.vue';
import Authentication from '../views/ecommerce/Authentication.vue';
import Coupon from '../views/ecommerce/Coupon.vue';
import Couponcodeprint from '../views/ecommerce/CouponPrint.vue';
import Offers from '../views/ecommerce/Offers.vue';
import CartEnd from '../views/ecommerce/CartEnd.vue';
import Blogs from '../views/blogs/Index.vue';
import Whatsapp from '../views/whatsapp/Index.vue';
import PushNotifications from '../views/ecommerce/PushNotifications.vue';

import { checkauth, hasWebsiteFramework } from '../Helper';

// inserimento, modifica e dettaglio sono pagine: tornando indietro la lista riparte dal suo URL
const EmailTemplateCreate = () => import('../views/ecommerce/emailtemplate/Create.vue');
const EmailTemplateEdit = () => import('../views/ecommerce/emailtemplate/Edit.vue');
const PageCreate = () => import('../views/ecommerce/pages/Create.vue');
const PageEdit = () => import('../views/ecommerce/pages/Edit.vue');
const PageOrder = () => import('../views/ecommerce/pages/Order.vue');
const ShippingMethodCreate = () => import('../views/ecommerce/shippingmethod/Create.vue');
const ShippingMethodEdit = () => import('../views/ecommerce/shippingmethod/Edit.vue');
const ShippingCostCreate = () => import('../views/ecommerce/shippingcost/Create.vue');
const ShippingCostEdit = () => import('../views/ecommerce/shippingcost/Edit.vue');
const ShippingCostBulk = () => import('../views/ecommerce/shippingcost/Bulk.vue');
const CouponCreate = () => import('../views/ecommerce/coupon/Create.vue');
const CouponEdit = () => import('../views/ecommerce/coupon/Edit.vue');
const Couponcode = () => import('../views/ecommerce/CouponCode.vue');
const OfferCreate = () => import('../views/ecommerce/offers/Create.vue');
const OfferEdit = () => import('../views/ecommerce/offers/Edit.vue');
const CartEndCreate = () => import('../views/ecommerce/cartend/Create.vue');
const BlogEdit = () => import('../views/blogs/Edit.vue');
const Loyalty = () => import('../views/ecommerce/Loyalty.vue');
const LoyaltyReward = () => import('../views/ecommerce/loyalty/Reward.vue');
const LoyaltyRequests = () => import('../views/ecommerce/LoyaltyRequests.vue');
import PrintReceipt from '@/views/order/PrintReceipt.vue';

/**
 * Il Sito Ecommerce esiste solo con il nostro framework attivo: senza, queste pagine non hanno dati.
 * Il menu nasconde gia' la sezione, ma le URL restavano raggiungibili a mano da chiunque fosse loggato.
 */
const ecommerceGuard = (to, from, next) => {
	checkauth().then(async response => {
		if (!response) {
			return next('/login');
		}
		if (!(await hasWebsiteFramework())) {
			return next('/');
		}
		next();
	});
};

export default [
	{
		path: '/ecommerce/emailtemplate',
		name: 'EmailTemplate',
		component: EmailTemplate,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/emailtemplate/new',
		name: 'EmailTemplateCreate',
		component: EmailTemplateCreate,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/emailtemplate/:id([0-9a-fA-F]{24})',
		name: 'EmailTemplateEdit',
		component: EmailTemplateEdit,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/pages',
		name: 'Page',
		component: Page,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/pages/new',
		name: 'PageCreate',
		component: PageCreate,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/pages/order',
		name: 'PageOrder',
		component: PageOrder,
		beforeEnter: ecommerceGuard,
	},
	// :id e' l'id numerico della pagina (come per le categorie): e' la chiave di pages/detail
	{
		path: '/ecommerce/pages/:id(\\d+)',
		name: 'PageEdit',
		component: PageEdit,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/layout',
		name: 'Layout',
		component: Layout,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentmethod',
		name: 'ShippingMethod',
		component: ShippingMethod,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentmethod/new',
		name: 'ShippingMethodCreate',
		component: ShippingMethodCreate,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentmethod/:id([0-9a-fA-F]{24})',
		name: 'ShippingMethodEdit',
		component: ShippingMethodEdit,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentcost',
		name: 'ShippingCost',
		component: ShippingCost,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentcost/new',
		name: 'ShippingCostCreate',
		component: ShippingCostCreate,
		beforeEnter: ecommerceGuard,
	},
	// duplica e modifica massiva del listino di un metodo verso un paese (?method=&country=)
	{
		path: '/ecommerce/shipmentcost/duplicate',
		name: 'ShippingCostDuplicate',
		component: ShippingCostBulk,
		props: { mode: 'duplicate' },
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentcost/bulk-edit',
		name: 'ShippingCostBulkEdit',
		component: ShippingCostBulk,
		props: { mode: 'edit' },
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/shipmentcost/:id([0-9a-fA-F]{24})',
		name: 'ShippingCostEdit',
		component: ShippingCostEdit,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/highlightedcategories',
		name: 'HighlightedCategories',
		component: HighlightedCategories,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/authentication',
		name: 'Authentication',
		component: Authentication,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/coupon',
		name: 'Coupon',
		component: Coupon,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/coupon/new',
		name: 'CouponCreate',
		component: CouponCreate,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/coupon/:id([0-9a-fA-F]{24})',
		name: 'CouponEdit',
		component: CouponEdit,
		beforeEnter: ecommerceGuard,
	},
	// codici emessi da una regola: l'_id della regola nell'URL, cosi' regge refresh e link diretti
	{
		path: '/ecommerce/coupon/:id([0-9a-fA-F]{24})/codes',
		name: 'Couponcode',
		component: Couponcode,
		beforeEnter: ecommerceGuard,
	},
	// vecchio indirizzo dei codici (la regola stava solo in memoria): si riparte dalle regole
	{
		path: '/ecommerce/couponcode',
		redirect: '/ecommerce/coupon',
	},
	{
		path: `/ecommerce/couponcode/print/:id`,
		name: `Couponcodeprint`,
		component: Couponcodeprint,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/offers',
		name: 'Offers',
		component: Offers,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/offers/new',
		name: 'OfferCreate',
		component: OfferCreate,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/offers/:id([0-9a-fA-F]{24})',
		name: 'OfferEdit',
		component: OfferEdit,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/blogs',
		name: 'Blogs',
		component: Blogs,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/blogs/:id([0-9a-fA-F]{24})',
		name: 'BlogEdit',
		component: BlogEdit,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/cartend',
		name: 'CartEnd',
		component: CartEnd,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/cartend/new',
		name: 'CartEndCreate',
		component: CartEndCreate,
		beforeEnter: ecommerceGuard,
	},
	// scheda a punti: impostazioni e premi, pagina del singolo premio, richieste di riscatto
	{
		path: '/ecommerce/loyalty',
		name: 'Loyalty',
		component: Loyalty,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/loyalty/rewards/new',
		name: 'LoyaltyRewardCreate',
		component: LoyaltyReward,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/loyalty/rewards/:id([0-9a-fA-F]{24})',
		name: 'LoyaltyRewardEdit',
		component: LoyaltyReward,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/loyalty/requests',
		name: 'LoyaltyRequests',
		component: LoyaltyRequests,
		beforeEnter: ecommerceGuard,
	},
	{
		path: '/ecommerce/push-notifications',
		name: 'PushNotifications',
		component: PushNotifications,
		beforeEnter: ecommerceGuard,
	},
];
